/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetTeamsCompanyFromSalesInvoiceDto
 */
export interface GetTeamsCompanyFromSalesInvoiceDto {
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCompanyFromSalesInvoiceDto
     */
    id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTeamsCompanyFromSalesInvoiceDto
     */
    teamIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCompanyFromSalesInvoiceDto
     */
    companyId: string;
}

/**
 * Check if a given object implements the GetTeamsCompanyFromSalesInvoiceDto interface.
 */
export function instanceOfGetTeamsCompanyFromSalesInvoiceDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "companyId" in value;

    return isInstance;
}

export function GetTeamsCompanyFromSalesInvoiceDtoFromJSON(json: any): GetTeamsCompanyFromSalesInvoiceDto {
    return GetTeamsCompanyFromSalesInvoiceDtoFromJSONTyped(json, false);
}

export function GetTeamsCompanyFromSalesInvoiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTeamsCompanyFromSalesInvoiceDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'teamIds': !exists(json, 'teamIds') ? undefined : json['teamIds'],
        'companyId': json['companyId'],
    };
}

export function GetTeamsCompanyFromSalesInvoiceDtoToJSON(value?: GetTeamsCompanyFromSalesInvoiceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'teamIds': value.teamIds,
        'companyId': value.companyId,
    };
}

